import GeneralNotice from '@pelckmans/elementis/components/general-notice';
import { useTranslation } from 'react-i18next';
import { UserMaterial } from '../../../api/user-material';
import AddBundleMaterialButton from '../AddBundleMaterialButton';
import { Module } from '../../../api/module';

interface Props {
  module: Module;
  nodeId: string;
  onMaterialAdded: (material: UserMaterial) => void;
}

export default function EmptyState({ module, nodeId, onMaterialAdded }: Props) {
  const { t } = useTranslation();

  return (
    <GeneralNotice
      className="empty-state"
      text={t('SHARED_COMPONENTS.ADD_BUNDLE.MATERIAL_LIST.EMPTY.TITLE')}
      subText={t('SHARED_COMPONENTS.ADD_BUNDLE.MATERIAL_LIST.EMPTY.SUBTEXT')}
      action={<AddBundleMaterialButton module={module} nodeId={nodeId} onMaterialAdded={onMaterialAdded} />}
    />
  );
}
